import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names intelligently.
 *
 * - Accepts any clsx input (string, array, object with boolean values).
 * - Resolves conflicts: later utilities override earlier ones (e.g.
 *   `cn('p-2', condition && 'p-4')` keeps `p-4` when condition is true).
 *
 * Used by every shadcn/ui primitive — do not rename.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
